/**
 * True when a Radix dismiss event originated in another overlay layer — a sibling or
 * stacked dialog, or a portaled popper (Select, Popover). Those land outside our own
 * content, so Radix reports them as an outside interaction and would dismiss us.
 *
 * Focus is the path that matters: Radix skips `onPointerDownOutside` on layers below a
 * modal one, but `onFocusOutside` has no such guard, so a dialog opening on top and
 * autofocusing dismisses everything underneath it.
 */
export function isEventFromOverlayLayer(event: Event): boolean {
  const target = event.target;
  if (!(target instanceof Element)) return false;

  return target.closest('[role="dialog"], [data-radix-popper-content-wrapper]') !== null;
}
